function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 1.75A.75.75 0 012.75 1h3.5a.75.75 0 01.592 1.21L4.284 5.5H6.25a.75.75 0 110 1.5h-3.5a.75.75 0 01-.592-1.21L4.717 2.5H2.75A.75.75 0 012 1.75zm3.205 6.744a.75.75 0 00-1.41 0l-2 5.5a.75.75 0 101.41.512L3.39 14h2.222l.184.506a.75.75 0 101.41-.513l-2-5.5zM3.935 12.5l.565-1.556.566 1.556H3.935zM12.5 1.75a.75.75 0 00-1.5 0v10.69l-.72-.72a.75.75 0 10-1.06 1.06l2 2a.75.75 0 001.06 0l2-2a.75.75 0 10-1.06-1.06l-.72.72V1.75z"
});

function SvgTextSortDescending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgTextSortDescending;